import React from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!
export function App() {
  return <div className="bg-white text-gray-900 min-h-screen w-full" data-id="element-0">
      <Header data-id="element-1" />
      <div className="relative" data-id="element-2">
        <main className="max-w-3xl mx-auto px-4 pb-20" data-id="element-3">
          <Hero data-id="element-4" />
          <InsiderStory data-id="element-5" />
          <ProblemSection data-id="element-6" />
          <SolutionSection data-id="element-7" />
          <TestimonialsSection data-id="element-8" />
          <ComparisonSection data-id="element-9" />
          <PricingSection data-id="element-10" />
          <CallToAction data-id="element-11" />
        </main>
        <StickyCart data-id="element-12" />
      </div>
      <Footer data-id="element-13" />
    </div>;
}
const Header = () => {
  return <header className="py-4 px-6 border-b border-gray-200" data-id="element-14">
      <div className="max-w-3xl mx-auto flex justify-between items-center" data-id="element-15">
        <div className="text-xl font-serif" data-id="element-16">BEAUTY INSIDER</div>
        <nav className="hidden md:block" data-id="element-17">
          <ul className="flex space-x-6 text-sm" data-id="element-18">
            <li data-id="element-19">SKINCARE</li>
            <li data-id="element-20">MAKEUP</li>
            <li data-id="element-21">WELLNESS</li>
            <li data-id="element-22">REVIEWS</li>
          </ul>
        </nav>
      </div>
    </header>;
};
const Hero = () => {
  return <section className="py-12" data-id="element-23">
      <h1 className="text-3xl md:text-4xl font-serif mb-6 leading-tight" data-id="element-24">
        Beauty Industry EXPOSED: Why Your $200 Serums Aren't Working (And The
        $89 Device That Changes Everything)
      </h1>
      <div className="aspect-video mb-8 overflow-hidden" data-id="element-25">
        <img src="https://www.health.com/thmb/l_GQqWhZWA5uFIVwcAxQwoW2-bY=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/SkincareOrder-d41e059245db42b39e16e2c516c7bd09.jpg" alt="Person applying skincare product" className="w-full h-full object-cover" data-id="element-26" />
      </div>
      <p className="text-lg mb-8" data-id="element-27">
        I'm about to share something that's going to make you mad. Really mad.
      </p>
      <p className="mb-6" data-id="element-28">
        Because the beauty industry has been lying to you about why your
        expensive skincare isn't working—and I have the receipts.
      </p>
    </section>;
};
const InsiderStory = () => {
  return <section className="py-8 border-t border-gray-200" data-id="element-29">
      <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-30">
        <div className="md:w-1/2" data-id="element-31">
          <img src="https://images.unsplash.com/photo-1544717305-2782549b5136?q=80&w=400&auto=format&fit=crop" alt="Sarah Chen, Beauty Industry Insider" className="w-full rounded-lg" data-id="element-32" />
        </div>
        <div className="md:w-2/3" data-id="element-33">
          <p className="mb-4" data-id="element-34">
            My name is Sarah Chen, and for the past six years, I've worked
            inside the beauty industry. I've formulated products for major
            brands, sat in boardroom meetings, and yes... I've helped sell you
            $200 serums knowing they barely work.
          </p>
          <p className="mb-4" data-id="element-35">
            Last month, I found a confidential company study buried deep in our
            research files. What I discovered made me physically sick to my
            stomach. And it's why I'm writing this exposé, even though it means
            burning every bridge I've built in this industry.
          </p>
          <p className="mb-4" data-id="element-36">
            What I'm about to show you will change how you think about skincare
            forever. More importantly, it's going to save you thousands of
            dollars and finally give you the results you've been desperately
            chasing.
          </p>
        </div>
      </div>
    </section>;
};
const ProblemSection = () => {
  return <section className="py-8 border-t border-gray-200" data-id="element-37">
      <h2 className="text-2xl font-serif mb-6" data-id="element-38">
        Have You Ever Wondered Why Your Expensive Skincare Just... Sits There?
      </h2>
      <p className="mb-4" data-id="element-39">
        You know the feeling. You spend $150 on that "miracle" serum everyone's
        raving about. You apply it religiously every morning and night. And
        after a month... nothing. Maybe your skin feels a tiny bit softer, but
        those fine lines are still there. That puffiness hasn't budged. Your
        jawline still looks soft in selfies.
      </p>
      <p className="mb-4" data-id="element-40">
        So what do you do? You blame yourself. "Maybe I'm not using enough."
        "Maybe I need to give it more time." "Maybe I need to add that $200
        vitamin C serum too."
      </p>
      <p className="mb-4" data-id="element-41">And the cycle continues.</p>
      <div className="bg-gray-100 p-6 my-8 border-l-4 border-red-500" data-id="element-42">
        <p className="text-xl mb-2" data-id="element-43">
          Here's what that confidential study revealed:
        </p>
        <p className="text-2xl font-bold text-red-400" data-id="element-44">
          73% of skincare products never penetrate beyond the surface layer of
          your skin.
        </p>
      </div>
      <p className="mb-8" data-id="element-45">
        Let me say that again. Nearly three-quarters of that expensive serum
        you're slathering on your face every day? It's just sitting on top,
        doing absolutely nothing except making cosmetic companies rich.
      </p>
      <h3 className="text-xl font-serif mb-4" data-id="element-46">The $2.3 Billion Skincare Lie</h3>
      <p className="mb-4" data-id="element-47">
        It started when I found that buried study three months ago. I was doing
        research for a new anti-aging line we were launching, and I stumbled
        across an internal report that was never meant to see daylight.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8" data-id="element-48">
        <div className="bg-gray-100 p-6" data-id="element-49">
          <p className="text-lg mb-2" data-id="element-50">Average serum absorption rate:</p>
          <p className="text-xl font-bold text-red-400" data-id="element-51">12-15%</p>
        </div>
        <div className="bg-gray-100 p-6" data-id="element-52">
          <p className="text-lg mb-2" data-id="element-53">Money wasted annually:</p>
          <p className="text-xl font-bold text-red-400" data-id="element-54">$2.3 billion</p>
        </div>
        <div className="bg-gray-100 p-6" data-id="element-55">
          <p className="text-lg mb-2" data-id="element-56">Success rate of traditional skincare:</p>
          <p className="text-xl font-bold text-red-400" data-id="element-57">23%</p>
        </div>
        <div className="bg-gray-100 p-6" data-id="element-58">
          <p className="text-lg mb-2" data-id="element-59">
            Repurchase due to "hope" rather than results:
          </p>
          <p className="text-xl font-bold text-red-400" data-id="element-60">67%</p>
        </div>
      </div>
    </section>;
};
const SolutionSection = () => {
  return <section className="py-8 border-t border-gray-200" data-id="element-61">
      <h2 className="text-2xl font-serif mb-6" data-id="element-62">
        The Breakthrough That Changed Everything
      </h2>
      <p className="mb-4" data-id="element-63">
        The answer didn't come from another serum. It came from watching what
        actually works.
      </p>
      <p className="mb-5" data-id="element-64">
        Three months ago, I was getting a facial at an elite spa in Beverly
        Hills (research, I told myself). The aesthetician was using this sleek
        device that combined heat, light, and vibration. Within minutes, I could
        see my skin transforming. Not just temporarily—actually changing.
      </p>
      <div className="flex flex-col md:flex-row gap-8 my-10 items-center" data-id="element-65">
        <div className="md:w-1/1" data-id="element-66">
          <img src="https://vraikobeauty.com/cdn/shop/files/LILY_A_2.png?v=1684162792&width=800" alt="VRAIKO Lily device" className="w-full rounded-lg" data-id="element-67" />
        </div>
        <div className="md:w-1/2" data-id="element-68">
          <h3 className="text-xl font-serif mb-4" data-id="element-69">Meet VRAIKO Lily.</h3>
          <p className="mb-4" data-id="element-70">
            This isn't another beauty gadget. It's a professional-grade skincare
            delivery system that transforms any serum, oil, or treatment into a
            spa-level experience.
          </p>
          <p className="mb-4" data-id="element-71">Here's how it works:</p>
          <ul className="list-disc pl-5 space-y-2 mb-6" data-id="element-72">
            <li data-id="element-73">
              <span className="font-bold" data-id="element-74">Thermal Activation (95°F):</span>{' '}
              Gentle, controlled heat opens your pores and softens your skin
              barrier, increasing absorption by over 300%.
            </li>
            <li data-id="element-75">
              <span className="font-bold" data-id="element-76">Triple LED Therapy:</span> Red light
              (anti-aging), blue light (clarity), and green light (calming)
              penetrate deep into skin cells.
            </li>
            <li data-id="element-77">
              <span className="font-bold" data-id="element-78">Precision Vibration:</span> 6,000
              micro-pulses per minute stimulate lymphatic drainage and enhance
              circulation.
            </li>
          </ul>
          <p className="font-bold" data-id="element-79">
            The result? Your existing serums become three times more effective.
            Instantly.
          </p>
        </div>
      </div>
    </section>;
};
const TestimonialsSection = () => {
  return <section className="py-8 border-t border-gray-200" data-id="element-80">
      <h2 className="text-2xl font-serif mb-6" data-id="element-81">
        The Proof: Real Women, Real Results
      </h2>
      <p className="mb-6" data-id="element-82">
        When I first started testing VRAIKO Lily, I was skeptical. After six
        years of seeing skincare promises fall flat, I needed concrete proof
        this actually worked.
      </p>
      <div className="space-y-12 my-8" data-id="element-83">
        <div className="flex flex-col md:flex-row gap-6" data-id="element-84">
          <div className="md:w-1/2" data-id="element-85">
            <img src="https://ecotan.co.nz/cdn/shop/files/Eco-tan-clear-skin-system-2.jpg?v=1744245634" alt="Sarah M." className="w-full rounded-lg" data-id="element-86" />
          </div>
          <div className="md:w-3/4" data-id="element-87">
            <h3 className="text-xl font-serif mb-2" data-id="element-88">
              Sarah M., 22, College Student from Austin
            </h3>
            <p className="italic mb-4" data-id="element-89">
              "I've never seen my skincare actually WORK before. My $30
              drugstore serum is now better than the $200 one I used to buy.
              This device paid for itself in the first month."
            </p>
            <div className="space-y-2" data-id="element-90">
              <p data-id="element-91">
                <span className="font-bold" data-id="element-92">Week 1:</span> "I noticed my serums
                actually sinking in instead of just sitting there. The puffiness
                was way less when I woke up."
              </p>
              <p data-id="element-93">
                <span className="font-bold" data-id="element-94">Week 2:</span> "My jawline looked
                more defined. People started asking if I was using a new
                filter."
              </p>
              <p data-id="element-95">
                <span className="font-bold" data-id="element-96">Week 3:</span> "Friends were
                literally asking what I was doing differently. My skin looked
                firm and glowy."
              </p>
              <p data-id="element-97">
                <span className="font-bold" data-id="element-98">Week 4:</span> "I canceled my
                expensive facial appointment because I didn't need it anymore."
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-6" data-id="element-99">
          <div className="md:w-1/2" data-id="element-100">
            <img src="https://i.redd.it/0trgn95btcs01.jpg" alt="Maya P." className="w-full rounded-lg" data-id="element-101" />
          </div>
          <div className="md:w-3/4" data-id="element-102">
            <h3 className="text-xl font-serif mb-2" data-id="element-103">
              Maya P., 24, Marketing Assistant from Los Angeles
            </h3>
            <p className="italic mb-4" data-id="element-104">
              "This isn't just another tool—it's like having a professional
              facialist in my bathroom. My skin drinks up my serums now instead
              of just wearing them on the surface."
            </p>
            <div className="grid grid-cols-2 gap-4" data-id="element-105">
              <p data-id="element-106">
                <span className="font-bold" data-id="element-107">Day 7:</span> Skin texture
                noticeably smoother
              </p>
              <p data-id="element-108">
                <span className="font-bold" data-id="element-109">Day 14:</span> Visible reduction in
                morning puffiness (85% improvement)
              </p>
              <p data-id="element-110">
                <span className="font-bold" data-id="element-111">Day 21:</span> Increased firmness
                around jawline and cheeks
              </p>
              <p data-id="element-112">
                <span className="font-bold" data-id="element-113">Day 30:</span> Complete confidence
                transformation—started taking makeup-free selfies
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const ComparisonSection = () => {
  return <section className="py-8 border-t border-gray-200" data-id="element-114">
      <h2 className="text-2xl font-serif mb-6" data-id="element-115">
        How VRAIKO Lily Destroys the Competition
      </h2>
      <p className="mb-6" data-id="element-116">
        I've tested everything on the market. Here's how VRAIKO Lily compares to
        every other option:
      </p>
      <div className="space-y-8 my-8" data-id="element-117">
        <div className="bg-gray-100 p-6" data-id="element-118">
          <h3 className="font-serif text-xl mb-3" data-id="element-119">
            Traditional Gua Sha & Jade Rollers
          </h3>
          <div className="flex flex-col md:flex-row gap-4" data-id="element-120">
            <div className="md:w-2/3" data-id="element-121">
              <p className="mb-2" data-id="element-122">
                <span className="font-bold text-black-400" data-id="element-123">
                  What they promise:
                </span>{' '}
                Lymphatic drainage, reduced puffiness
              </p>
              <p className="mb-2" data-id="element-124">
                <span className="font-bold text-black-400" data-id="element-125">The reality:</span>{' '}
                Temporary effects that fade within hours. No absorption
                enhancement.
              </p>
              <p data-id="element-126">
                <span className="font-bold text-black-400" data-id="element-127">Cost:</span> $15-50
                (plus expensive oils needed to prevent damage)
              </p>
            </div>
            <div className="md:w-1/3 text-center" data-id="element-128">
              <p className="text-xl font-bold text-red-400" data-id="element-129">
                Effectiveness: 2/10
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-100 p-6" data-id="element-130">
          <h3 className="font-serif text-xl mb-3" data-id="element-131">
            Professional Microcurrent Devices (NuFACE, etc.)
          </h3>
          <div className="flex flex-col md:flex-row gap-4" data-id="element-132">
            <div className="md:w-2/3" data-id="element-133">
              <p className="mb-2" data-id="element-134">
                <span className="font-bold text-black-400" data-id="element-135">
                  What they promise:
                </span>{' '}
                Facial toning and lifting
              </p>
              <p className="mb-2" data-id="element-136">
                <span className="font-bold text-black-400" data-id="element-137">The reality:</span>{' '}
                Single-action technology. Requires expensive proprietary gels.
              </p>
              <p data-id="element-138">
                <span className="font-bold text-black-400" data-id="element-139">Cost:</span> $200-400
                + ongoing gel subscriptions
              </p>
            </div>
            <div className="md:w-1/3 text-center" data-id="element-140">
              <p className="text-xl font-bold text-yellow-400" data-id="element-141">
                Effectiveness: 6/10
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-100 p-6" data-id="element-142">
          <h3 className="font-serif text-xl mb-3" data-id="element-143">VRAIKO Lily</h3>
          <div className="flex flex-col md:flex-row gap-4" data-id="element-144">
            <div className="md:w-2/3" data-id="element-145">
              <ul className="list-none space-y-2" data-id="element-146">
                <li data-id="element-147">
                  ✅ Triple-action professional technology in one sleek device
                </li>
                <li data-id="element-148">✅ Makes ANY existing product 3x more effective</li>
                <li data-id="element-149">✅ Professional results in 5 minutes at home</li>
                <li data-id="element-150">✅ No ongoing costs or proprietary products required</li>
              </ul>
              <p className="mt-2" data-id="element-151">
                <span className="font-bold text-black-400" data-id="element-152">
                  Total investment:
                </span>{' '}
                $89 one-time cost
              </p>
            </div>
            <div className="md:w-1/3 text-center" data-id="element-153">
              <p className="text-xl font-bold text-green-400" data-id="element-154">
                Effectiveness: 9.5/10
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const PricingSection = () => {
  const handleClick = () => {
    window.location.href = 'https://www.elixora.co';
  };
  return <section className="py-8 border-t border-gray-200" data-id="element-155">
      <h2 className="text-2xl font-serif mb-6" data-id="element-156">
        Special Launch Offer - But Only for the Next 72 Hours
      </h2>
      <p className="mb-6" data-id="element-157">
        Because you've taken the time to read this exposé, and because I believe
        everyone deserves access to skincare that actually works, I'm offering
        VRAIKO Lily at the lowest price it will ever be available.
      </p>
      <div className="bg-gradient-to-r from-green-100 to-white-100 p-8 rounded-lg my-8" data-id="element-158">
        <h3 className="text-xl font-serif mb-4" data-id="element-159">What You Get Today:</h3>
        <p className="mb-2" data-id="element-160">✅ VRAIKO Lily Triple-Action Device ($129 value)</p>
        <div className="my-6 border-t border-b border-gray-300 py-4" data-id="element-161">
          <div className="flex justify-between items-center" data-id="element-162">
            <p className="text-lg" data-id="element-163">Total Value:</p>
            <p className="text-lg" data-id="element-164">$129</p>
          </div>
          <div className="flex justify-between items-center font-bold" data-id="element-165">
            <p className="text-xl" data-id="element-166">Your Price Today:</p>
            <p className="text-xl" data-id="element-167">Just $89</p>
          </div>
          <div className="flex justify-between items-center font-bold text-green-400" data-id="element-168">
            <p data-id="element-169">You Save:</p>
            <p data-id="element-170">$40</p>
          </div>
        </div>
        <p className="mb-4" data-id="element-171">✅ FREE shipping (normally $12)</p>
        <p className="mb-4" data-id="element-172">✅ Arrives in 3-5 business days</p>
        <button onClick={handleClick} className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg w-full text-lg transition-colors" data-id="element-173">
          SECURE YOUR VRAIKO LILY NOW
        </button>
        <p className="text-center mt-4 text-sm" data-id="element-174">
          Only 847 units remaining in stock
        </p>
      </div>
      <div className="bg-gray-100 p-6 my-8 border-l-4 border-green-500" data-id="element-175">
        <h3 className="text-xl font-serif mb-4" data-id="element-176">
          Your Risk-Free 30-Day Glow Guarantee
        </h3>
        <p className="mb-4" data-id="element-177">
          I'm so confident that VRAIKO Lily will transform your skincare routine
          that I'm backing it with the strongest guarantee in the beauty
          industry:
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-178">
          <li data-id="element-179">Use VRAIKO Lily for 30 full days.</li>
          <li data-id="element-180">
            If you don't see visible improvement in skin firmness, reduced
            puffiness, better serum absorption, and overall glow, return it for
            a complete refund.
          </li>
          <li data-id="element-181">No questions asked. No fine print. No hassle.</li>
        </ul>
      </div>
    </section>;
};
const CallToAction = () => {
  const handleClick = () => {
    window.location.href = 'https://www.elixora.co';
  };
  return <section className="py-8 border-t border-gray-200" data-id="element-182">
      <h2 className="text-2xl font-serif mb-6" data-id="element-183">
        Your Skincare Revolution Starts Right Now
      </h2>
      <p className="mb-4" data-id="element-184">You're at a crossroads.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8" data-id="element-185">
        <div className="bg-gray-100 p-6" data-id="element-186">
          <h3 className="font-serif text-xl mb-3" data-id="element-187">
            Option 1: Keep doing what you're doing
          </h3>
          <ul className="list-disc pl-5 space-y-2" data-id="element-188">
            <li data-id="element-189">Continue buying $200 serums that sit on your skin surface</li>
            <li data-id="element-190">Waste thousands more dollars on ineffective products</li>
            <li data-id="element-191">Watch your skin age while your bank account shrinks</li>
            <li data-id="element-192">Stay trapped in the beauty industry's profit cycle</li>
          </ul>
        </div>
        <div className="bg-gray-100 p-6" data-id="element-193">
          <h3 className="font-serif text-xl mb-3" data-id="element-194">
            Option 2: Break free with VRAIKO Lily
          </h3>
          <ul className="list-disc pl-5 space-y-2" data-id="element-195">
            <li data-id="element-196">
              Transform your existing products into professional-grade
              treatments
            </li>
            <li data-id="element-197">Save thousands on skincare that actually works now</li>
            <li data-id="element-198">Finally see the results you've been chasing for years</li>
            <li data-id="element-199">Take control of your skin's future</li>
          </ul>
        </div>
      </div>
      <div className="my-8" data-id="element-200">
        <p className="mb-4" data-id="element-201">The choice is yours.</p>
        <p className="mb-4" data-id="element-202">But remember:</p>
        <ul className="list-disc pl-5 space-y-2 mb-6" data-id="element-203">
          <li data-id="element-204">Only 847 units remain in stock</li>
          <li data-id="element-205">Industry pressure is mounting to restrict access</li>
          <li data-id="element-206">This price is only protected for the next 72 hours</li>
          <li data-id="element-207">Your 30-day guarantee protects you completely</li>
        </ul>
      </div>
      <button onClick={handleClick} className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg w-full text-lg transition-colors mb-4" data-id="element-208">
        SECURE YOUR VRAIKO LILY - 847 REMAINING
      </button>
      <p className="text-center text-sm" data-id="element-209">
        This isn't just about buying a device. It's about breaking free from an
        industry that profits from your disappointment and finally getting the
        skin you deserve.
      </p>
    </section>;
};
const Footer = () => {
  return <footer className="py-6 px-4 border-t border-gray-200" data-id="element-210">
      <div className="max-w-3xl mx-auto text-center text-sm text-gray-600" data-id="element-211">
        <p className="mb-2" data-id="element-212">© 2023 VRAIKO Beauty. All Rights Reserved.</p>
        <div className="flex justify-center space-x-4" data-id="element-213">
          <span data-id="element-214">Privacy Policy</span>
          <span data-id="element-215">Terms of Service</span>
          <span data-id="element-216">Contact</span>
        </div>
      </div>
    </footer>;
};
const StickyCart = () => {
  const handleClick = () => {
    window.location.href = 'https://www.elixora.co';
  };
  return <>
      {/* Desktop sticky sidebar */}
      <div className="hidden lg:block fixed right-8 top-24 w-80" data-id="element-217">
        <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-lg" data-id="element-218">
          <h3 className="text-xl font-serif mb-4" data-id="element-219">VRAIKO Lily Device</h3>
          <div className="space-y-3 mb-4" data-id="element-220">
            <div className="flex justify-between" data-id="element-221">
              <span data-id="element-222">Regular Price:</span>
              <span className="line-through" data-id="element-223">$129</span>
            </div>
            <div className="flex justify-between font-bold" data-id="element-224">
              <span data-id="element-225">Today's Price:</span>
              <span data-id="element-226">$89</span>
            </div>
            <div className="flex justify-between text-green-600 font-bold" data-id="element-227">
              <span data-id="element-228">You Save:</span>
              <span data-id="element-229">$40</span>
            </div>
          </div>
          <div className="border-t border-gray-200 py-4 mb-4" data-id="element-230">
            <div className="flex items-center justify-between mb-2" data-id="element-231">
              <span className="text-sm" data-id="element-232">Stock Level:</span>
              <span className="text-sm font-bold" data-id="element-233">847 remaining</span>
            </div>
            <div className="w-full bg-gray-200 h-2 rounded-full" data-id="element-234">
              <div className="w-1/3 bg-green-500 h-2 rounded-full" data-id="element-235"></div>
            </div>
          </div>
          <button onClick={handleClick} className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg w-full text-lg transition-colors mb-3" data-id="element-236">
            ADD TO CART - $89
          </button>
          <p className="text-center text-sm text-gray-600" data-id="element-237">
            ✓ 30-Day Money Back Guarantee
          </p>
        </div>
      </div>
      {/* Mobile sticky bottom bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4" data-id="element-238">
        <div className="flex items-center justify-between max-w-3xl mx-auto" data-id="element-239">
          <div data-id="element-240">
            <p className="text-sm line-through text-gray-500" data-id="element-241">$129</p>
            <p className="text-lg font-bold" data-id="element-242">$89</p>
          </div>
          <button onClick={handleClick} className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors" data-id="element-243">
            GET YOURS NOW!
          </button>
        </div>
      </div>
    </>;
};